import React, { FunctionComponent } from 'react'
import Svg, { Path, Rect } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { ThemeType } from '../../utils/themes/ThemeProvider'

export interface LyraHealthAppPromoIconProps {
  size?: number
  testID?: string
}

export const LyraHealthAppPromoIcon: FunctionComponent<LyraHealthAppPromoIconProps> = ({
  size = 48,
  testID = 'LyraHealthAppPromoIcon',
}) => {
  const { colors } = useTheme() as ThemeType

  return (
    <Svg width={size} height={size} viewBox='0 0 48 48' fill='none' testID={testID}>
      <Rect width='48' height='48' rx='12' fill={colors.icons.lyraHealthAppIcon.background.fill} />
      <Path
        d='M12.6062 26.4495C12.8694 26.4594 13.6199 26.4495 13.6199 26.4495V28.2238C13.6199 28.2238 12.9376 28.2238 12.6062 28.2238C11.6121 28.2238 9 28.0366 9 25.2469C9 22.063 9 15.2812 9 15.2812H10.7544C10.7544 15.2812 10.7544 23.2656 10.7544 24.7442C10.7544 26.1242 11.6608 26.4101 12.6062 26.4495ZM39 23.5318V28.2337H37.2554V27.2085C36.4561 27.8493 35.4522 28.2436 34.3509 28.2436C31.7875 28.2436 29.7018 26.144 29.7018 23.5416C29.7018 20.9393 31.7778 18.8397 34.3509 18.8397C36.9142 18.8397 39 20.9393 39 23.5318ZM37.2846 23.5318C37.2846 21.8955 35.9688 20.5647 34.3509 20.5647C32.7329 20.5647 31.4172 21.8955 31.4172 23.5318C31.4172 25.1681 32.7329 26.4988 34.3509 26.4988C35.9786 26.4988 37.2846 25.1681 37.2846 23.5318ZM29.2047 18.8397C27.5478 18.8397 26.5244 19.7466 25.9981 20.5647V18.8397H24.2437V28.2436H25.9981V24.1824C25.9981 22.4081 27.0994 20.5647 29.1267 20.5647H29.4776V18.8397H29.2047ZM21.232 18.82L18.23 25.9074L15.54 18.82H13.6491L17.2554 28.1844L15.2281 32.7188H17.2066L23.2008 18.82H21.232Z'
        fill={colors.icons.lyraHealthAppIcon.logo.fill}
      />
    </Svg>
  )
}
